import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {TextModel} from "models/Text"
import connect from "./connect"

interface ShowFiltersCloseButtonProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    isAnyFilterSelected: boolean
    text: TextModel
    closeFiltersPanel: (event: React.MouseEvent<HTMLButtonElement>) => void
    clearAll: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const ShowFiltersCloseButton = memo(
    ({templating, isAnyFilterSelected, closeFiltersPanel, clearAll, text}: ShowFiltersCloseButtonProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        return (
            <Suspense>
                <ComponentName
                    onClick={isAnyFilterSelected ? clearAll : closeFiltersPanel}
                    data-testid={isAnyFilterSelected ? "plp-filters-clear-all-text-cta" : "plp-filters-close-text-cta"}
                    disableRipple
                >
                    {isAnyFilterSelected ? text.buttons.clearAll : text.buttons.close}
                </ComponentName>
            </Suspense>
        )
    },
)
ShowFiltersCloseButton.displayName = "ShowFiltersCloseButton"
export default connect(ShowFiltersCloseButton)
